import { useLiveStreamAppContext } from "../ContextStore/Store";
import { appInsightTrack } from "../utils/AppInsights";
import ChangeButton from "./ChangeButton";
import axios from "axios";

const FetchPlayerSettings = () => {
  const {
    setIsNetworkError,
    setIsCam,
    setAttendees,
    apiUrlPost,
    __appConfirmUniqueID,
    __merchantId,
    __userId,
    role,
    serviceProviderId,
    headers,
    setToggleStates,
    eventType,
    callN,
    setDisableCam,
    setDisableMic,
    setIsChatDisabled,
    setIsInstructorMode,
    isInstructorModeRef,
    setIsMic,
    setAvtarInitials,
    setUserName,
    setLoaderAnimation,
    setErrorMessage,
    cameraPermission,
    microphonePermission
  } = useLiveStreamAppContext();

  const { changeButtonStatus } = ChangeButton();

  //function to call getplayersettings
  async function getplayersettings() {
    let attempt = 0;
    const fetchPlayerSettings = async () => {
      attempt++;
      try {
        setIsNetworkError(false);
        const playerSettingsResponse = await axios.post(
          `${apiUrlPost}playersettings`,
          {
            AppConfirmUniqueId: __appConfirmUniqueID,
            attendeeType: role === "Presenter" ? 1 : 2,
            serviceProviderId: serviceProviderId,
          },
          { headers }
        );
        const data =
          playerSettingsResponse.data.data.playerSettings?.[0] || null;
        if (data) {
          setToggleStates((prevStates) => ({
            ...prevStates,
            EnableChat: !data.isDisableChatforAllAttendes,
            EnableMic: !data.isDisableMichrophoneforAllAttendees,
            EnableScreenShare: !data.isDisableScreenShareforAllAttendees,
            EnableVideo: !data.isDisableVideoforAllAttendes,
            InstructorMode: eventType === 1 ? false : data.isInstructorOnlyMode,
            StartRecording: data.isStartRecording,
            blurBackground: data.isBlurBackGround,
            removeBackgroundNoise: data.isRemoveBackgroundNoise,
            shareDeviceAudio: data.isShareDeviceAudio,
            mirrorMyVideo: data.isMirrorVideo
          }));

          if (role === "Attendee") {
            if (data.isDisableMichrophoneforAllAttendees) {
              changeButtonStatus("micIconDiv", "micIcon", "DISABLE", "all");
              setToggleStates((prevStates) => ({
                ...prevStates,
                removeBackgroundNoise: false,
              }))
              setDisableMic(true);
              if (!callN.current?.isMuted && callN.current?.isMuted !== undefined) callN.current?.mute();
            } else {
              changeButtonStatus("micIconDiv", "micIcon", "ENABLE", "all");
              setDisableMic(false);
            }
          }

          if (role === "Attendee") {
            if (data.isDisableVideoforAllAttendes) {
              if (callN.current?.isLocalVideoStarted === true) {
                const localVideoStream =
                  callN.current.localVideoStreams.find((stream) => {
                    return stream.mediaStreamType === "Video";
                  });
                callN.current?.stopVideo(localVideoStream);
              }
              setDisableCam(true);
              changeButtonStatus("camIconDiv", "camIcon", "DISABLE", "all");
            } else {
              setDisableCam(false);
              changeButtonStatus("camIconDiv", "camIcon", "ENABLE", "all");
              setToggleStates((prevStates) => ({
                ...prevStates,
                EnableVideo: true,
              }));
            }
            setIsChatDisabled(data.isDisableChatforAllAttendes);
          }
          if (role === "Attendee") {
            if (data.isDisableChatforAllAttendes) {
              setToggleStates((prevStates) => ({
                ...prevStates,
                EnableChat: false,
              }));
            } else {
              setToggleStates((prevStates) => ({
                ...prevStates,
                EnableChat: true,
              }));
            }
          }
          if (role === "Presenter") {
            if (data.isDisableScreenShareforAllAttendees) {
              setAttendees((prevAttendees) =>
                prevAttendees.map((attendee) => ({
                  ...attendee,
                  isScreenShareDisabled: true,
                })));
            } else {
              setAttendees((prevAttendees) =>
                prevAttendees.map((attendee) => ({
                  ...attendee,
                  isScreenShareDisabled: false,
                })));
            }
          } else {
            if (data.isDisableChatforAllAttendes) {
              changeButtonStatus("screenShareIcon", "screenShareIcon", "DISABLE", "all");
            } else {
              changeButtonStatus("screenShareIcon", "screenShareIcon", "ENABLE", "all");
            }
          }
          if (eventType === 1) {
            setIsInstructorMode(false);
            isInstructorModeRef.current = false;
          }
          else {
            setIsInstructorMode(data.isInstructorOnlyMode);
            isInstructorModeRef.current = data.isInstructorOnlyMode;
          }


          setIsMic(!data.isMuteOwnAudio);
          setIsCam(!data.isMuteOwnVideo);

          if (data.isMuteOwnVideo) {
            let blurBackground = document.getElementById("blurBackgrounddiv");
            !blurBackground?.classList.contains("divDisabled") && blurBackground?.classList.add("divDisabled");
            let mirrorMyVideo = document.getElementById("mirrorMyVideodiv");
            !mirrorMyVideo?.classList.contains("divDisabled") && mirrorMyVideo?.classList.add("divDisabled");
            setToggleStates((prev) => ({
              ...prev,
              mirrorMyVideo: false,
              blurBackground: false
            }))
          } else {
            if (cameraPermission === "granted") {
              let blurBackground = document.getElementById("blurBackgrounddiv");
              blurBackground?.classList.contains("divDisabled") && blurBackground?.classList.remove("divDisabled");
              let mirrorMyVideo = document.getElementById("mirrorMyVideodiv");
              mirrorMyVideo?.classList.contains("divDisabled") && mirrorMyVideo?.classList.remove("divDisabled");
            }
          }

          if (data.isMuteOwnAudio) {
            let removeBackgroundNoise = document.getElementById("removeBackgroundNoisediv");
            !removeBackgroundNoise?.classList.contains("divDisabled") && removeBackgroundNoise?.classList.add("divDisabled");
            setToggleStates((prev) => ({
              ...prev,
              removeBackgroundNoise: false
            }))
          } else {
            if (microphonePermission === "granted") {
              let removeBackgroundNoise = document.getElementById("removeBackgroundNoisediv");
              removeBackgroundNoise?.classList.contains("divDisabled") && removeBackgroundNoise?.classList.remove("divDisabled");
            }
          }

          if (data?.screenName?.length > 0) {
            if (role === "Attendee") {
              setUserName(data.screenName);
              setAvtarInitials(data.screenName);
            }
          }
          setLoaderAnimation(false);
        }
        else {
          setToggleStates((prevStates) => ({
            ...prevStates,
            StartRecording: true,
            EnableMic: true,
            EnableVideo: true,
            EnableChat: true,
            EnableScreenShare: true,
            FitToFrame: false,
            InstructorMode: eventType === 1 ? false : false,
            blurBackground: false,
            removeBackgroundNoise: false,
            shareDeviceAudio: false,
            mirrorMyVideo: true
          }));
          // setRecordingAlert(true)
          setIsMic(true);
          setIsCam(true)
          setIsInstructorMode(eventType === 1 ? false : false);
          isInstructorModeRef.current = true;
          data?.screenName?.length > 0 &&
            role === "Attendee" &&
            setUserName(data.screenName);
          setLoaderAnimation(false);
        }
        if (cameraPermission !== "granted" || microphonePermission !== "granted") {
          setToggleStates((prevStates) => ({
            ...prevStates,
            shareDeviceAudio: false,
            removeBackgroundNoise: false,
            mirrorMyVideo: false,
            blurBackground: false,
            FitToFrame: false
          }))
        }
      } catch (error) {
        setLoaderAnimation(false);
        if (error.message.toLowerCase().includes("failed to fetch")) {
          setErrorMessage("You can not host Live Stream Appointment of another employee.");
        }
        else {
          setErrorMessage(error.message);
        }
        console.error("Error fetching get player Settings Response", error);
        appInsightTrack(__merchantId, __userId, "API Error playersettings", "", error);

        // Retry up to 3 times if there is an error
        if (attempt < 3) {
          await fetchPlayerSettings();
          return; // Exit the current function execution to prevent duplicate loading state toggles
        }
      }
    };
    await fetchPlayerSettings();
  }
  return { getplayersettings }
}

export default FetchPlayerSettings